import Button from '../../App/Button'
import Input from '../../App/Input'
import style from './LoginPage.module.css'
import inputStyle from '../../App/Input/Input.module.css'
import { type FormEvent } from 'react'

import { useStore } from '../../stores'
import { observer } from 'mobx-react'
import EnekaLogo from '../../assets/images/eneka.svg'
import { type LoginCredentials } from 'stores/UserStore'
import { useForm } from 'react-hook-form'

const LoginPage = observer(() => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors }
  } = useForm<LoginCredentials>()
  // const [error, setError] = useState(null)
  const { user } = useStore()

  const onSubmit = (e: FormEvent): void => {
    e.preventDefault()
    void handleSubmit((data) => {
      void user.loginWithEmailAndPassword(data).catch(() => {
        setError('root', {
          message: 'Ein Fehler ist aufgetreten. Bitte Eingaben prüfen.'
        })
      })
    })(e)
  }

  return (
    <div className="w-full h-full flex flex-row bg-white">
      <div className="flex w-full lg:w-1/2 h-full min-h-screen">
        <img
          className="w-full h-full object-cover"
          src="/enekaLogin.jpg"
          alt=""
        />
      </div>
      <div className="flex flex-col justify-center items-start w-full h-screen lg:w-1/2 px-14">
        <div className="flex flex-col">
          <div className="flex items-start justify-center h-9 w-40 mb-10">
            <img src={EnekaLogo} alt="" />
          </div>
          <span className="font-light text-4xl mb-6">ENEKA.Energieplanung</span>
          <span className="font-medium text-base">
            Kartografische Toolbox für die lokale Energiewende
          </span>
          <form className={style.form} onSubmit={onSubmit}>
            <div className="mb-3">
              <span className="font-black text-lg">
                Bitte loggen Sie sich ein
              </span>
            </div>
            <div className="mb-3">
              <Input
                className={
                  errors.email !== undefined
                    ? inputStyle.inputError
                    : inputStyle.input
                }
                label="E-Mail-Adresse"
                placeholder="E-Mail-Adresse"
                type="text"
                autoComplete="email"
                labelCSS="block font-medium text-blue-midnight text-base"
                {...register('email', {
                  required: 'Die E-Mail darf nicht leer sein.'
                })}
              />
              {errors.email !== undefined && <p>{errors.email.message}</p>}
            </div>
            <div className="mb-3">
              <Input
                className={
                  errors.password !== undefined
                    ? inputStyle.inputError
                    : inputStyle.input
                }
                label="Passwort"
                placeholder="Passwort"
                type="password"
                autoComplete="current-password"
                labelCSS="block font-medium text-blue-midnight text-base"
                {...register('password', {
                  required: 'Das Passwort darf nicht leer sein.'
                })}
              />
              {errors.password !== undefined && (
                <p>{errors.password.message}</p>
              )}
            </div>
            {errors.root !== undefined && (
              <div className="text-red-punch text mb-3">
                {errors.root.message}
              </div>
            )}
            <div className={style.button}>
              <a
                href="https://eneka.de/fromapplikation/"
                className="text-green-default text-base w-auto self-center"
              >
                Passwort vergessen?
              </a>
              <Button
                label="Login"
                filled
                type="submit"
                data-testid="login-button"
                customCSS="w-42 h-12 justify-center font-bold text-base"
                id="login-submit-button-id"
              />
            </div>
          </form>
          <div className="flex flex-col text-base text-blue-midnight">
            <span>Sie möchten gerne Zugang zur ENEKA Energieplanung?</span>
            <span>
              Bitte kontaktieren Sie uns{' '}
              <a
                href="https://eneka.de/fromapplikation/"
                className="text-green-default"
              >
                hier
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
})

export default LoginPage
